import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { initializeSetOption } from "../../../../utils/InitializeSetDefault";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import ButtonOptionSubmenu from "../../../../components/ButtonOptionSubmenu";
import { Card, Form } from "react-bootstrap";
import Table from "../../../../components/Table";
import { formatInputDate, toFormatISO } from "../../../../utils/Time";
import { formatDate } from "../../../../commons/FormatValue";
import { getServiceRequest, addEditServiceRequest } from "../../../../commons/ServiceRequest";
import TechnicianReceiveService from "../../../../services/technicianreceive.service";
import { filteredCreateNewKey } from "../../../../utils/ManageArray";
import { useLoading } from "../../../../context/LoadingContext";
import InputSearch from "../../../../components/InputSearhComponent";
import { getQueryString } from "../../../../utils/Query";
import CustomersService from "../../../../services/customer.service";
import TableLimitPagination from "../../../../components/TableLimitPagination";
import PropTypes from "prop-types";
import moment from "moment";
import TableForm2s from "../../../../components/TableFormScrb";

export default function TeamDetail({ defaultData }) {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { state } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [searchValue, setSearchValue] = useState([]);
  const [JobType, setJobType] = useState([]);
  const [WorkNo, setWorkNo] = useState([]);
  const [CustomerCode, setCustomerCode] = useState([]);
  const [CustomerName, setCustomerName] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limitTable, setLimitTable] = useState(10);
  const [allCountData, setAllCountData] = useState();
  const [querySearch, setQuerySearch] = useState()

  const searchInput = [
    {
      name: "tech_mas_name",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "text",
      disabled: true,
      size: 4,
      value: defaultData.tech_name
    },
    {
      name: "tech_rev_no",
      label: "เลขที่รับงาน",
      classNames: { label: "mb-3" },
      size: 4,
      filterBy: ["tech_rev_no"],
      options: initializeSetOption({
        key: "tech_rev_no",
        label: "tech_rev_no",
        dataset: WorkNo
      }),
      queryService: (query, value) => {
        const q = getQueryString({ tech_rev_no: value, limit: 100, page: 1, plan_status: "NOT-OPEN" })
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: TechnicianReceiveService.getReceiveNo(q),
          callback: (res) => {
            const newArray = res.data.map(arr => ({
              tech_rev_no: arr.tech_rev_no
            }))
            setWorkNo(newArray)
          }
        });
      }
    },
    {
      name: "date",
      label: "วันที่รับงาน",
      classNames: { label: "mb-3" },
      type: "date",
      size: 4
    },
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      type: "text",
      disabled: true,
      size: 4,
      value: defaultData.team
    },
    {
      name: "seq_no",
      label: "เลขที่ใบสั่งงาน",
      classNames: { label: "mb-3" },
      size: 4,
      filterBy: ["seq_no"],
      options: initializeSetOption({
        key: "seq_no",
        label: "seq_no",
        dataset: WorkNo
      }),
      queryService: (query, value) => {
        const q = getQueryString({ seq_no: value, plan_status: "NOT-OPEN", limit: 100, page: 1 })
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: TechnicianReceiveService.getSeqNo(q),
          callback: (array) => {
            const newArray = array.map(arr => ({
              seq_no: arr.seqJob.seqNo
            }))
            setWorkNo(newArray)
          }
        });
      }
    },
    {
      name: "job_type_id",
      label: "ประเภทงาน",
      classNames: { label: "mb-3" },
      size: 4,
      noneAsync: true,
      filterBy: ["Job_Type_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Job_Type_Name",
        dataset: JobType
        // dataset: filteredItemInArray(
        //   data,
        //   "Job_Type_Name",
        //   data.Job_Type_Name
        // )
      })
    },
    {
      name: "cus_code",
      label: "รหัสลูกค้า/สาขา",
      classNames: { label: "mb-3" },
      size: 4,

      filterBy: ["Cus_Code"],
      options: initializeSetOption({
        key: "Cus_Code",
        label: "Cus_Code",
        dataset: CustomerCode
      }),
      queryService: (query) => {
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: CustomersService.getAllCustomers(query),
          callback: ({ items }) => setCustomerCode(items)
        });
      }
    },
    {
      name: "cus_name",
      label: "ชื่อลูกค้า/สาขา",
      classNames: { label: "mb-3" },
      size: 8,
      filterBy: ["Cus_Name"],
      options: initializeSetOption({
        key: "Cus_Name",
        label: "Cus_Name",
        dataset: CustomerName
      }),
      queryService: (query) => {
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: CustomersService.getAllCustomers(query),
          callback: ({ items }) => setCustomerName(items)
        });
      }
    }
  ];

  const columns = [
    // {
    //   name: "ลำดับ",
    //   selector: (row) => row.rowIndex,
    //   sortable: true,
    //   minWidth: "50px",
    //   // center: true,
    // },
    {
      label: "วันที่รับงาน",
      name: "Tech_Rev_Date",
      readOnly: true,
      minWidth: "160px",
      format: (row) => formatDate(row.Tech_Rev_Date)
    },
    {
      label: "เลขที่รับงาน",
      name: "Tech_Rev_No",
      readOnly: true,
      minWidth: "180px"
    },
    {
      label: "ประเภทงาน",
      name: "Job_Type_Id",
      readOnly: true,
      format: (row) => JobType.find(item => item.Id === row.Job_Type_Id)?.Job_Type_Name,
      minWidth: "200px"
    },
    {
      label: "เลขที่ใบสั่งงาน",
      name: "Seq_No",
      // selector: (row) => row.Seq_No,
      readOnly: true,
      minWidth: "200px"
    },
    {
      label: "รหัสลูกค้า/สาขา",
      name: "Cus_Code",
      selector: (row) => row.Cus_Code,
      readOnly: true,
      minWidth: "200px"
    },
    {
      label: "ชื่อลูกค้า/สาขา",
      name: "Cus_Name",
      selector: (row) => row.Cus_Name,
      readOnly: true,
      width: "250px",
      showTooltip: true
    },
    {
      label: "วันที่เข้างาน",
      name: "Job_Cus_Date",
      selector: (row) => row.Job_Cus_Date,
      format: (row) => formatDate(row?.Job_Cus_Date),
      readOnly: true,
      // minWidth: "160px"
    },
    {
      label: "สถานะงาน",
      name: "Depart_St_Name",
      selector: (row) => row.Depart_St_Name,
      // format: (row) => JobType.filter(item => item.Id === row.Job_Type_Id)[0]?.Job_Type_Name,
      readOnly: true,
      minWidth: "200px"
    },
    {
      label: "สถานะใบสั่งงาน",
      name: "Seq_St_Name",
      selector: (row) => row.Seq_St_Name,
      readOnly: true,
      minWidth: "200px"
    },
    {
      label: "",
      type: "activeButton"
    }
    // {
    //   name: "",
    //   selector: (row) => (
    //     <ButtonOptionSubmenu
    //       data={row}
    //       state={{ preview: (row) }}
    //       previewButton
    //       editButton
    //       deleteButton
    //       onDeleteCallback={handleSubmitDelete}
    //     />
    //   ),
    //   right: true,
    //   minWidth: "220px"
    // }
  ];

  useEffect(() => {
    setJobType(defaultData.job_type)
  }, [defaultData]);

  const getDataTable = (search) => {
    const page = search?.page || currentPage
    const limit = search?.limit || limitTable
    const q = ({
      ...querySearch,
      page: page, limit: limit, ...search,
      start: toFormatISO(search.date),
      end: toFormatISO(search?.date)
    })
    setQuerySearch(q)
    setCurrentPage(page)
    setLimitTable(limit)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechnicianReceiveService.getJobAccept(getQueryString(q)),
      callback: (res) => { pSetData(res.data); setMainData(res.data); setAllCountData(res.allCount) }
    });

  }

  const pSetData = (vData) => {
    const newArray = vData?.map((items) => ({
      Id: items.id,
      Tech_Rev_Date: formatInputDate(items.tech_rev_date, "Local").date,
      Tech_Rev_No: items.tech_rev_no,
      // Job_Type_Name: items.TechnicianPlan.SeqOthersJob?.InformOtherJob?.JobType?.Job_Type_Name,
      Job_Type_Id: items.job_type_id,
      Seq_No: items.TechnicianPlan.SeqOthersJob?.Seq_Oth_No ||
        items.TechnicianPlan.SeqPmJob?.Seq_Pm_No ||
        items.TechnicianPlan.RepairJobs?.seq_repair_no ||
        items.TechnicianPlan.SeqInstalljob?.seq_install_no,
      // Tech_Doc_No: items?.tech_doc_no,
      // Tech_Doc_Date: formatInputDate(items.Tech_Doc_Date, "Local").date,
      Contract_No: items?.TechnicianPlan?.SeqOthersJob?.InformOtherJob.Contract_No ||
        items.TechnicianPlan?.SeqInstalljob?.InformInstallJobs.Contract_No ||
        items.TechnicianPlan?.RepairJobs?.informRepairJob.Contract_No,
      Job_Actual_Date: formatInputDate(items.job_actual_date, "Local").date,
      Depart_St_Id: items.depart_st_id,
      Depart_St_Name: items.TechnicianPlan.DepartJob?.Depart_St_Name,
      // Seq_St_Name: items.TechnicianPlan.TechnicianReceive[0]?.SequneceStatus?.Seq_St_Name, //items.TechnicianPlan.SequneceStatus?.Seq_St_Name,
      Seq_St_Name: items.SequneceStatus?.Seq_St_Name, //items.TechnicianPlan.SequneceStatus?.Seq_St_Name,
      Cus_Code: items.TechnicianPlan?.SeqOthersJob?.InformOtherJob?.Customer?.Cus_Code ||
        items.TechnicianPlan?.SeqInstalljob?.InformInstallJobs?.Customer?.Cus_Code ||
        items.TechnicianPlan?.RepairJobs?.informRepairJob?.concern_customer_items?.Cus_Code,
      Cus_Name: items.TechnicianPlan?.SeqOthersJob?.InformOtherJob?.Customer?.Cus_Name ||
        items.TechnicianPlan?.SeqInstalljob?.InformInstallJobs?.Customer?.Cus_Name ||
        items.TechnicianPlan?.RepairJobs?.informRepairJob?.concern_customer_items?.Cus_Name,
      Tech_Mas_Name: items.Technician?.Tech_Mas_Name,
      Job_Cus_Date: formatInputDate(
        items.TechnicianPlan.job_actual_date
        // items.TechnicianPlan.SeqOthersJob?.InformOtherJob?.Job_Cus_Date ||
        // items.TechnicianPlan?.SeqInstalljob?.InformInstallJobs?.Job_Cus_Date
        , "Local").date,
      Tech_Reject: (items.tech_reject ? "Reject" : "Accept"),
      Reject_Reason: items.reject_reason
    }));
    setData(newArray);
    setSearchValue(newArray || [])
  };

  const handleSubmitDelete = (event, dataCallback) => {
    event.preventDefault();

    if (dataCallback) {
      handleSubmitPlanDel(dataCallback.Id, true);
      // getMainData();
      // setSearchValue([]);
    }
  };

  const handleSubmitPlanDel = async (id) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechnicianReceiveService.deleteTechnicianReceive(id, true),
      // navigated: (navi) => navi && navigate("/service_work/acceptance", {
      //   state: { name: "JobDetails" }
      // })
      navigated: () => getDataTable()
    });
  };

  const handleSearchFilter = (search) => {
    const newSearch = filteredCreateNewKey({
      data: data,
      search: search,
      newName: ["Id"],
    });

    let filteredData = data.filter((item) =>
      newSearch.some(({ name, value }) => item[name] === value)
    );

    filteredData = filteredData.map(({ ...rest }) => ({ ...rest }));
    setSearchValue(search.length !== 0 ? filteredData : []);
  };

  return (
    <>
      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Header
          className="bg-transparent border-0 text-center"
          style={{ fontSize: "24px" }}
        >
          ข้อมูลการรับงาน
        </Card.Header>
        <Card.Body>
          {/* <SearchFilter */}
          <InputSearch
            data={data}
            inputField={searchInput}
            field={searchInput}
            // fieldClassName={{ inputRow: "justify-content-end align-items-center", actionButton: "w-auto py-2" }}
            // searchCallback={handleSearchFilter}
            searchCallback={search => { search ? getDataTable(search) 
              : setSearchValue([]); setQuerySearch({}); setData([]) }}
          />
        </Card.Body>
      </Card>

      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
          <Card.Title className="mb-0 fs-2 text-dark">
            รายละเอียดงาน
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Form noValidate>
            <TableForm2s
              data={data}
              columns={columns}
              isLoading={loading}
              searchFilter={searchValue}
              pagination
              rowsPerPage={limitTable}
              currentPage={currentPage}
              rowCount={allCountData}
              previewButton
              editButton
              deleteButton
              onDeleteCallback={handleSubmitDelete}
              fetchData={pag => {
                if (pag?.limit) setLimitTable(pag.limit)
                getDataTable({
                  ...querySearch,
                  page: pag.page,
                  limit: pag?.limit || limitTable
                });
              }}
            />
          </Form>
          {/* <Table
            data={searchValue}
            column={columns}
            pending={loading}
            searchFilter={searchValue}
          />
          {!loading &&
            <TableLimitPagination
              data={searchValue}
              paginationProps={{
                rowsPerPage: limitTable,
                currentPage: currentPage,
                rowCount: allCountData,
                onChangeRowsPerPage: num => getDataTable({ limit: num, page: 1 }),
                onChangePage: page => getDataTable({ page: page })
              }}
            />
          } */}
        </Card.Body>
      </Card>
    </>
  );
}

TeamDetail.propTypes = {
  defaultData: PropTypes.object,
};